import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';
import Box from '@mui/material/Box/Box';
import { getTeamFeedback } from '../../services/vote.service';

/**
 * What the judges wrote for this team, without their names. Shown to the team's members once results are
 * announced (organizers any time; the server decides who gets it).
 */
export const TeamFeedback = ({ hackathonId, ideaId }: { hackathonId: string, ideaId: string }) => {
    const [feedback, setFeedback] = useState<string[] | null>(null);

    useEffect(() => {
        getTeamFeedback(hackathonId, ideaId).then(setFeedback, err => {
            console.error(err);
            setFeedback([]);
        });
    }, [hackathonId, ideaId]);

    // the Results card links here; the section only exists once loaded, so scroll then
    useEffect(() => {
        if (feedback !== null && window.location.hash === '#feedback') {
            document.getElementById('feedback')?.scrollIntoView();
        }
    }, [feedback]);

    if (feedback === null) {
        return null;
    }

    return (
        <Stack spacing={1} id="feedback" sx={{ scrollMarginTop: 88 }}>
            <h3>Feedback from the judges</h3>
            {
                feedback.length === 0
                    ? <Typography color="text.secondary">The judges didn't leave written feedback for this team.</Typography>
                    : feedback.map((text, index) => (
                        <Box key={index} sx={{ backgroundColor: 'var(--surface-muted)', borderRadius: '12px', p: 2, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                            <Typography>{text}</Typography>
                        </Box>
                    ))
            }
        </Stack>
    );
}
